var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_286_437)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 0H6.5C4.57 0 3 1.57 3 3.5V7C3 7.55 3.45 8 4 8C4.55 8 5 7.55 5 7V3.5C5 2.67 5.67 2 6.5 2C7.33 2 8 2.67 8 3.5C8 4.88 9.12 6 10.5 6H19V19C19 20.65 17.65 22 16 22H14C13.45 22 13 22.45 13 23C13 23.55 13.45 24 14 24H16C18.76 24 21 21.76 21 19V6H21.5C22.88 6 24 4.88 24 3.5V3C24 1.35 22.65 0 21 0ZM22 3.5C22 3.78 21.78 4 21.5 4H10.5C10.22 4 10 3.78 10 3.5C10 2.96 9.88 2.45 9.66 2H21C21.55 2 22 2.45 22 3V3.5ZM8.5 10H3.5C1.57 10 0 11.57 0 13.5V20.5C0 22.43 1.57 24 3.5 24H8.5C10.43 24 12 22.43 12 20.5V13.5C12 11.57 10.43 10 8.5 10ZM10 20.5C10 21.33 9.33 22 8.5 22H3.5C2.67 22 2 21.33 2 20.5V13.5C2 12.67 2.67 12 3.5 12H8.5C9.33 12 10 12.67 10 13.5V20.5ZM9 14C9 14.55 8.55 15 8 15H4C3.45 15 3 14.55 3 14C3 13.45 3.45 13 4 13H8C8.55 13 9 13.45 9 14ZM9 17C9 17.55 8.55 18 8 18H7.5C6.95 18 6.5 17.55 6.5 17C6.5 16.45 6.95 16 7.5 16H8C8.55 16 9 16.45 9 17ZM5.5 17C5.5 17.55 5.05 18 4.5 18H4C3.45 18 3 17.55 3 17C3 16.45 3.45 16 4 16H4.5C5.05 16 5.5 16.45 5.5 17ZM9 20C9 20.55 8.55 21 8 21H7.5C6.95 21 6.5 20.55 6.5 20C6.5 19.45 6.95 19 7.5 19H8C8.55 19 9 19.45 9 20ZM5.5 20C5.5 20.55 5.05 21 4.5 21H4C3.45 21 3 20.55 3 20C3 19.45 3.45 19 4 19H4.5C5.05 19 5.5 19.45 5.5 20Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_286_437"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.72e7764508a59785938733d83e55929e.svg";
export { ForwardRef as ReactComponent };